module.exports = __webpack_public_path__ + "img/fbd4fc1.png";